import type { ComponentProps } from "react";

import { cn } from "../../lib/cn";

export function Textarea({ className, ...props }: ComponentProps<"textarea">) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        "flex min-h-[80px] w-full rounded-control border border-outline bg-surface-container px-3 py-2 text-sm text-on-surface shadow-sm transition-colors",
        "placeholder:text-on-surface-muted",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-focus-ring focus-visible:border-focus-ring",
        "disabled:cursor-not-allowed disabled:opacity-50",
        "aria-invalid:border-error aria-invalid:ring-error",
        className,
      )}
      {...props}
    />
  );
}
